import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { FilterModel } from '../../../shared/models/filter.model';
import { TableEventModel } from '../../../shared/models/table-events.model';
import { parseParamsFromObject } from '../../../shared/utils/params-from-objects.map';
import { DefaultDataWrapper } from '../../../shared/models/default-data-wrapper.model';
import { Limit } from '../models/limit.model';
import { LimitByIdModel } from '../models/limit-by-id.model';
import { isLimitDriverPayload, LimitCarPayload, LimitDriverPayload } from '../models/limit-payload.model';
import { ServicesDictionary } from '../models/services-dictionary.model';
import { Pageable } from '../../../shared/models/pageable';

@Injectable({ providedIn: 'root' })
export class LimitsApiService {
  private http = inject(HttpClient);

  searchLimits(filter: FilterModel, tableEvent: TableEventModel): Observable<DefaultDataWrapper<Pageable<Limit>>> {
    const params = parseParamsFromObject({
      ...filter,
      ...tableEvent
    });
    return this.http.get<DefaultDataWrapper<Pageable<Limit>>>('/corporate-client/limit/searchLimits', { params });
  }

  getLimitById(id: string): Observable<LimitByIdModel> {
    return this.http.get<LimitByIdModel>(`/corporate-client/limit/${id}/list`);
  }

  saveLimit(payload: LimitDriverPayload | LimitCarPayload): Observable<any> {
    if (isLimitDriverPayload(payload)) {
      return this.http.post('/corporate-client/limit/saveDriverLimits', payload);
    } else {
      return this.http.post('/corporate-client/limit/saveMachineryLimits', payload);
    }
  }

  getServicesDictionary(): Observable<DefaultDataWrapper<ServicesDictionary>> {
    return this.http.get<DefaultDataWrapper<ServicesDictionary>>('/corporate-client/product/list');
  }
}
